"use client"
import React from "react";

import "@/components/shared/EventDateAndTime.css";

const EventDateAndTime = ({
  startDate,
  endDate,
  multiDay,
  titleAs = "span",
  subtitleAs = "span",
  className
}) => {
  const validTitleLevels = ["h3", "h4", "p", "span"];
  const validSubitleLevels = ["h4", "p", "span"];

  const safeTitle = titleAs ? titleAs.toLowerCase() : "";
  const Title = validTitleLevels.includes(safeTitle) ? safeTitle : "h3";

  const safeSubtitle = subtitleAs ? subtitleAs.toLowerCase() : "";
  const Subtitle = validSubitleLevels.includes(safeSubtitle)
    ? safeSubtitle
    : "h4";

  if (startDate && endDate) {
    return (
      <div
        className={`event-date-and-time ${
          multiDay ? "multi-day" : ""
        } ${className}`}
      >
        {multiDay ? (
          <Title className="text-color start-date">
            {startDate.format("MMMM DD, YYYY")} -{" "}
            {endDate.format("MMMM DD, YYYY")}
          </Title>
        ) : (
          <>
            <Title className="text-color start-date">
              {startDate.format("MMMM DD, YYYY")}
            </Title>
            {/*{titleAs === "span" && subtitleAs === "span" && <br />}*/}
            <Subtitle className="text-color time-range">
              {startDate.format("h:mm a")} - {endDate.format("h:mm a")}
            </Subtitle>
          </>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};
export default EventDateAndTime;
